import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { resolveColor, SYMBOL_MAP } from "../blockTypeConstants";

const BulletListPreview = ({ blockItems, bulletColor, colorOptions = [], startIndex = 0 }) => {
    const bulletColorHex = resolveColor(bulletColor, colorOptions);

    return (
        <div className="block-preview-card">
            <ul className="bullet-preview-list dynamic-list">
                {blockItems
                    .filter((item) => String(item?.item || item?.text || "").trim().length > 0)
                    .map((item, idx) => {
                        const prefixType = item?.prefixType || item?.bulletType || "dot";
                        const rowColor = resolveColor(item?.bulletColor || bulletColor, colorOptions);
                        const marker = prefixType === "number" ? `${startIndex + idx + 1}.` : SYMBOL_MAP[prefixType] || "•";
                        const itemText = item?.item || item?.text || "";

                        return (
                            <li key={`${itemText || "bullet"}-${idx}`}>
                                <span className="bullet-marker" style={{ color: rowColor || bulletColorHex }}>
                                    {prefixType === "check" ? <CheckCircleOutlined /> : marker}
                                </span>
                                <span>{itemText}</span>
                            </li>
                        );
                    })}
            </ul>
        </div>
    );
};

export default BulletListPreview;
